import CookieConsent from 'react-cookie-consent';

const CookieNotice = (): JSX.Element => {
  return <CookieConsent>This website uses cookies to enhance the user experience.</CookieConsent>;
};

export default CookieNotice;
